import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import PublicSEO from '../../components/public/PublicSEO';
import { publicPath } from '../../utils/canonicalUrl';
import { buildBreadcrumb } from '../../utils/jsonLd';
import './ContentGuide.css';

/** Indice pagine SEO pubblicate (prestazione × città). */
export default function ServiziIndexPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/seo/servizi')
      .then((res) => setItems(Array.isArray(res.data) ? res.data : []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="vc-guide">
      <PublicSEO
        title="Servizi e prestazioni per città"
        description="Pagine informative su prestazioni mediche e zone coperte da Virtual Clinic. Dalla pagina puoi passare alla ricerca disponibilità."
        canonicalPath="/servizi"
        jsonLd={[
          buildBreadcrumb([
            { name: 'Home', path: '/' },
            { name: 'Servizi' },
          ]),
        ]}
      />
      <div className="vc-guide__inner">
        <h1>Servizi</h1>
        <p className="vc-guide__lead">
          Guide su prestazioni e città. Per prenotare usa sempre la ricerca disponibilità.
        </p>
        <section>
          {loading && <p>Caricamento…</p>}
          {!loading && items.length === 0 && (
            <p>
              Non ci sono ancora pagine pubblicate. Puoi comunque{' '}
              <Link to={publicPath('/ricerca')}>cercare disponibilità</Link>.
            </p>
          )}
          {!loading && items.length > 0 && (
            <ul>
              {items.map((it) => (
                <li key={it.slug}>
                  <Link to={publicPath(`/servizi/${it.slug}`)}>
                    {it.h1 || it.title || it.slug}
                  </Link>
                  {it.citta ? ` — ${it.citta}` : ''}
                </li>
              ))}
            </ul>
          )}
          <div className="vc-guide__cta-row">
            <Link to={publicPath('/ricerca')} className="vc-guide__cta">Cerca disponibilità</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
